const gavelWhite = '/static/images/pro-bidder-membership/GavelWhite.png';
const gavelOrange = '/static/images/pro-bidder-membership/GavelOrange.png';
const gavelGrey = '/static/images/pro-bidder-membership/GavelGrey.png';
const gavelYellow = '/static/images/pro-bidder-membership/GavelYellow.png';

interface Membership {
    title: string;
    color: string;
    imageSrc: string;
    monthlyFee: string;
    buyerPremium: string;
    premiumMinimum: string;
    bidRadius: string;
    maxBidLimit: string;
    highBidderLimit: string;
    authorizedForPickup: string;
    dedicatedEmailSupport: boolean;
    dedicatedPhoneSupport: boolean;
    suspensionReview: boolean;
    backupOffers: boolean;
    buttonLink: string;
    buttonText: string;
    maxBidLimitDisclaimer?: string;
    highBidderLimitDisclaimer?: string;
    maxBackupBidderOffersDisclaimer?: string;
}

export const membershipData: Membership[] = [
    {
        title: 'Basic Bidder',
        color: 'white',
        imageSrc: gavelWhite,
        monthlyFee: '$0',
        buyerPremium: '18%',
        premiumMinimum: '$10',
        bidRadius: '300',
        maxBidLimit: '$1,000*',
        highBidderLimit: '3 auctions',
        authorizedForPickup: '0',
        dedicatedEmailSupport: false,
        dedicatedPhoneSupport: false,
        suspensionReview: false,
        backupOffers: false,
        buttonLink: 'false',
        buttonText: '$0 / Month',
        maxBidLimitDisclaimer: 'Restriction removed after 5 won auctions',
        highBidderLimitDisclaimer: 'Restriction removed after 5 won auctions',
        maxBackupBidderOffersDisclaimer: 'Restriction removed after 5 won auctions',
    },
    {
        title: 'ProBidder',
        color: '#CD7F32',
        imageSrc: gavelOrange,
        monthlyFee: '$10',
        buyerPremium: '15%',
        premiumMinimum: '$10',
        bidRadius: '500',
        maxBidLimit: '$1,000*',
        highBidderLimit: '5 auctions',
        authorizedForPickup: '1',
        dedicatedEmailSupport: true,
        dedicatedPhoneSupport: true,
        suspensionReview: true,
        backupOffers: true,
        buttonLink: 'false',
        buttonText: '$10 / Month',
        maxBidLimitDisclaimer: 'Restriction removed after 3 won auctions',
        highBidderLimitDisclaimer: 'Restriction removed after 3 won auctions',
    },
    {
        title: 'ProBidder Max',
        color: '#C0C0C0',
        imageSrc: gavelGrey,
        monthlyFee: '$20',
        buyerPremium: '12%',
        premiumMinimum: '$10',
        bidRadius: '1000',
        maxBidLimit: 'No Limit',
        highBidderLimit: 'Unlimited',
        authorizedForPickup: '3',
        dedicatedEmailSupport: true,
        dedicatedPhoneSupport: true,
        suspensionReview: true,
        backupOffers: true,
        buttonLink: 'false',
        buttonText: '$20 / Month',
    },
    {
        title: 'ProBusiness',
        color: '#CEA936',
        imageSrc: gavelYellow,
        monthlyFee: '$30',
        buyerPremium: '9%',
        premiumMinimum: '$10',
        bidRadius: 'Unlimited',
        maxBidLimit: 'No Limit',
        highBidderLimit: 'Unlimited',
        authorizedForPickup: '5',
        dedicatedEmailSupport: true,
        dedicatedPhoneSupport: true,
        suspensionReview: true,
        backupOffers: true,
        buttonLink: 'false',
        buttonText: '$30 / Month',
    },
];
